import React from 'react';
import { SEARCH_ICON } from '../utilities/generatedClasses';
import Icon from './Icon';
import { classNameTriskeleParser } from '../utilities/customStyles';

const SearchMeasure = (props) => {
  const { measures, onFilteredMeasures } = props;

  const searchMeasure = (value) => {
    if (value == '') {
      onFilteredMeasures(measures);
      return;
    }
    const result = [];
    measures.forEach((measure) => {
      result.push({
        name: measure.name,
        order: measure.order,
        values: measure.values.filter(x => (x.ReportName ? x.ReportName.toLowerCase().includes(value.toLowerCase()) : x.MeasureName.toLowerCase().includes(value.toLowerCase())))
      });
    });
    onFilteredMeasures(result);
  };
  return (
    <div className="card_search" style={{ border: 'none', boxShadow: 'none', borderRadius: '0px', margin: '0', top: '220px'}}>
      <div className={`${classNameTriskeleParser("Search Bar", "Searched Boxed", "Rectangle")}`}
       style={{ display: 'flex', padding: '7.5px', boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.2)', borderRadius: '4px', zIndex: 999, width: '100%' }}>
          <Icon classNames={`large_size_40 ${SEARCH_ICON}`} />
          <input
            className="input_search"
            onChange={e => searchMeasure(e.target.value)}
            placeholder="Search Measure" />
        </div>
    </div>
  
  );
};

export default SearchMeasure;
